import SettingsExpertTeamDetailsModule from './team-details.module'

export default SettingsExpertTeamDetailsModule
